import type { ComponentProps, FunctionComponent } from 'react';

import { Card, FROSTED_SURFACE_CLASSES } from './Card';

export { FROSTED_SURFACE_CLASSES };

/** Frosted, non-interactive card surface — shorthand for `<Card surface="frosted">`. */
export const StandaloneCard: FunctionComponent<Omit<ComponentProps<typeof Card>, 'surface'>> = (props) => (
    <Card {...props} surface="frosted" />
);
